import { EntraIcon, O365OneDriveIcon, O365SharePointIcon, O365TeamsIcon } from "@sg-protect/components";
import type { ComponentType } from "react";
import type { AssessmentOverview, Int32DataPoint } from "#api/types.ts";
import type { workspacePaths } from "#paths.ts";

type AssessmentPathKey = keyof Pick<
    typeof workspacePaths,
    | "migrationProjectOverview"
    | "migrationProjectIdentities"
    | "migrationProjectOneDrive"
    | "migrationProjectSharePoint"
    | "migrationProjectTeams"
>;

interface AssessmentTabDef {
    pathKey: AssessmentPathKey;
    label: string;
    icon?: ComponentType<{ className?: string; size?: "sm" | "md" | "lg" }>;
    iconSize?: "sm" | "md" | "lg";
    getTotal?: (overview: AssessmentOverview) => Int32DataPoint | undefined;
}

export const ASSESSMENT_TABS: AssessmentTabDef[] = [
    { pathKey: "migrationProjectOverview", label: "Overview" },
    {
        pathKey: "migrationProjectIdentities",
        label: "Identities",
        icon: EntraIcon,
        iconSize: "sm",
        getTotal: overview => overview.user?.count
    },
    {
        pathKey: "migrationProjectOneDrive",
        label: "OneDrive",
        icon: O365OneDriveIcon,
        getTotal: overview => overview.oneDrive?.count
    },
    {
        pathKey: "migrationProjectSharePoint",
        label: "SharePoint",
        icon: O365SharePointIcon,
        getTotal: overview => overview.sharePoint?.count
    },
    {
        pathKey: "migrationProjectTeams",
        label: "Teams",
        icon: O365TeamsIcon,
        getTotal: overview => overview.teams?.teamsCount
    }
];
